import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Signup from "../components/Signup";
import Login from "../components/Login";
import Dashboard from "../components/client/Dashboard";
import AddStore from "../components/agent/AddStore";

import AgentLogin from "../components/agent/Login";

import PriceChecker from "../components/agent/PriceChecker";
import AddProduct from "../components/agent/AddProduct";
import Stores from "../components/agent/Stores";
import Homepage from "../components/Homepage";
import PageNotFound from "../components/404";
import * as paths from "./paths";
import AuthRoute from "./CustomRoutes/AuthRoute";

const Routes = () => (
  <div>
    <Router>
      <Switch>
        <Route path={paths.HOMEPAGE} component={Homepage} exact />
        <Route path={paths.LOGIN} component={Login} />
        <Route path={paths.REGISTER} component={Signup} />
        <Route path={paths.AGENT_LOGIN} exact component={AgentLogin} />
        {/*  Agents Links from agents folder */}
        
        <AuthRoute path={paths.VIEW_PRODUCTS_AGENTS} component={PriceChecker} />
        <AuthRoute path={paths.ADD_PRODUCTS_AGENTS} component={AddProduct} />
        <AuthRoute path={paths.ADD_STORE_AGENTS} component={AddStore} />
        <AuthRoute path={paths.VIEW_STORES} component={Stores} />

        {/* Clents Links from clents folder */}
        <Route path={paths.DASHBOARD_CLIENT} component={Dashboard} />

        {/* Error Pages */}
        <Route path="*" component={PageNotFound} />
      </Switch>
    </Router>
  </div>
);

export default Routes;
